export function Spacer({ size = 1 }: { size: number }) {
  return <div style={{ height: size * 8 }} />;
}